import actions from '@/core/store/configuracao/revisoes/actions'
import mutations from '@/core/store/configuracao/revisoes/mutations'
import state from '@/core/store/configuracao/revisoes/state'
import modeloDocumentoRevisao from '@/core/store/configuracao/revisoes/modelo-documento-revisao'

export default {
	actions,
	mutations,
	state,
	modules: {
		modeloDocumentoRevisao,
	},
}
